export default "__VITE_ASSET__BOaf13$v__"